import React from "react";
import { useMutation } from "@tanstack/react-query";
import { deleteScheduleItem } from "api";
import { Modal, Spinner } from "components/common";
import type { ScheduleItem } from "types";

export function DeleteModal({
  item,
  partnerName,
  onClose,
  onSuccess,
}: {
  item:        ScheduleItem;
  partnerName: string;
  onClose:     () => void;
  onSuccess:   () => void;
}) {
  const { mutate, isPending } = useMutation({
    mutationFn: () => deleteScheduleItem(item.id),
    onSuccess,
  });

  return (
    <Modal title="Delete pickup" onClose={onClose}>
      <p className="text-sm text-gray-600 mb-4">
        Are you sure you want to delete the pickup from <strong>{partnerName}</strong>? This action cannot be undone.
      </p>
      <div className="flex gap-3">
        <button className="btn-secondary" onClick={onClose}>Cancel</button>
        <button
          className="btn-primary bg-red-600 hover:bg-red-700"
          disabled={isPending}
          onClick={() => mutate()}
        >
          {isPending ? <Spinner className="h-4" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
}
